import React from 'react';
import DlpRules from '@Policy/DataLossPrevention/PolicyTemplate/Filters/Dlp';
import { useGlobalSettingStore } from '@Models/useGlobalSettingModel';

const DlpRulesExchange = () => {
  const { selectedOrgGlobalSetting } = useGlobalSettingStore();
  const mipFeatureShow = !!selectedOrgGlobalSetting?.mipFeatureShow;
  return (
    <DlpRules
      applyBoundShow={false}
      scanTargetShow={false}
      complianceRuleNoteShow={false}
      advancedOptionsShow={false}
      fileAdvancedOptionsShow={true}
      mipShow={mipFeatureShow}
    />
  );
};
export default DlpRulesExchange;
